export default "__VITE_ASSET__aed64f5c__"